export default __webpack_public_path__ + "static/media/carouselFour.01207c70.png";